import React from 'react';

function code({ eleItem, handleInputChange, i }) {
  return (
    <>
      <input type="text" name="code" className="form-control text-bordered" value={eleItem.code} onChange={(e) => handleInputChange(e, eleItem, i)} />
      <span className="error-message">{eleItem?.errors?.includes('code') && 'Please enter care code'}</span>
    </>
  );
}
export default code;
